"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.send = exports.sendAll = void 0;
var request_1 = __importDefault(require("./request"));
var configuration_1 = require("./configuration");
var chunk_1 = __importDefault(require("../utils/chunk"));
var date_1 = require("../utils/date");
var websocket_1 = require("./websocket");
/**
 * end multiple events
 */
var sendAll = function (config, hits, reply) {
    if (reply === void 0) { reply = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url, promises, results, response, _i, results_1, r, _a, r_1, i;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, configuration_1.getServerUrlWithVersion)(config)];
                case 1:
                    url = _b.sent();
                    promises = (0, chunk_1.default)(hits, 50)
                        .map(function (_hits) { return (0, request_1.default)(config)
                        .post("".concat(url, "send"), {
                        api_key: config.apiKey,
                        hits: _hits,
                        reply: reply,
                    }); });
                    return [4 /*yield*/, Promise.all(promises)];
                case 2:
                    results = (_b.sent());
                    response = [];
                    if (Array.isArray(results)) {
                        for (_i = 0, results_1 = results; _i < results_1.length; _i++) {
                            r = results_1[_i];
                            if (!Array.isArray(r))
                                continue;
                            for (_a = 0, r_1 = r; _a < r_1.length; _a++) {
                                i = r_1[_a];
                                response.push(i);
                            }
                        }
                    }
                    return [2 /*return*/, response];
            }
        });
    });
};
exports.sendAll = sendAll;
/**
 * send single event
 */
var send = function (config, event_entity, reply) {
    if (reply === void 0) { reply = false; }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, (0, exports.sendAll)(config, [event_entity], reply)
            /**
             * send handler
             */
        ];
    }); });
};
exports.send = send;
/**
 * send handler
 */
var Send = function (config) {
    var _send = function (event, entity) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, exports.send)(config, {
                        event: __assign({ measured: (0, date_1.getMeasuredDate)() }, event),
                        entity: entity
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var _sendAll = function (list) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, exports.sendAll)(config, list.map(function (_a) {
                        var event = _a.event, entity = _a.entity;
                        return ({
                            event: __assign({ measured: (0, date_1.getMeasuredDate)() }, event),
                            entity: entity
                        });
                    }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var start = Date.now();
    return {
        // utils
        restingTime: function () { return Date.now() - start; },
        restingTimeReset: function () { return start = Date.now(); },
        getMeasuredDate: date_1.getMeasuredDate,
        // websockets
        pageview: function (entity, event) {
            if (event === void 0) { event = {}; }
            return (0, websocket_1.Pageview)(config, entity, __assign({ measured: (0, date_1.getMeasuredDate)() }, event));
        },
        // http
        send: function (event, entity) { return _send(event, entity); },
        sendAll: function (list) { return _sendAll(list); },
        sendClick: function (entity, event) {
            if (event === void 0) { event = {}; }
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _send(__assign(__assign({}, event), { event_type: "click" }), entity)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        sendRendered: function (entities, event) {
            if (event === void 0) { event = {}; }
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _sendAll(entities.map(function (entity) { return ({
                                event: __assign(__assign({}, event), { event_type: "rendered" }),
                                entity: entity,
                            }); }))];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
    };
};
exports.default = Send;
